import { ApiService } from './api.service';
import { StudentGroupingResult } from '@/models/student/student-grouping-result';
import { AddSchoolGroupRequest } from '@/models/school-group/add-school-group-request';
import { SchoolGroupRespose } from '@/models/school-group/school-group-response';

class StudengGroupingResultService extends ApiService {
  constructor() {
    super();
  }

  getStudengGroupingResult(targetType: number = 0, targetID: number = 0, tagIDs: string = '', groupNum: number = 0, groupType: number = 0, growingPurpose: number = 0, schoolCompetencyID: number = 0): Promise<StudentGroupingResult> {
    return this.get(StudentGroupingResult, `schoolGroups/proposal`, {
      targetType,
      targetID,
      tagIDs,
      groupNum,
      groupType,
      growingPurpose,
      schoolCompetencyID,
    });
  }

  addSchoolGroup(params: AddSchoolGroupRequest): Promise<SchoolGroupRespose> {
    return this.post(SchoolGroupRespose, 'schoolGroups', params);
  }
}

export const studengGroupingResultService = new StudengGroupingResultService();
